import {
  DirectorLicensingFeePerRateBreakdown,
  LicensingFeePerRateBreakdown,
  LicensingFeePerRateBreakdownFeeEnum,
  TutorLicensingFeePerRateBreakdown,
} from '../../../../swagger'
import {
  convertTwoDecimalStringToBig,
  formatBigFixedTwoDecimals,
} from '../../../../utils/bigJSHelper'

export const prepareLicensingData = <
  T extends
    | LicensingFeePerRateBreakdown
    | DirectorLicensingFeePerRateBreakdown
    | TutorLicensingFeePerRateBreakdown
>(
  breakdown: T[]
): {
  semester1FirstStudentsInfo: LicensingFeePerRateBreakdown
  semester1AdditionalStudentInfo: LicensingFeePerRateBreakdown
  semester2FirstStudentsInfo: LicensingFeePerRateBreakdown
  semester2AdditionalStudentInfo: LicensingFeePerRateBreakdown
  firstSpotInvitation: LicensingFeePerRateBreakdown
  additionalSpotsInvitation: LicensingFeePerRateBreakdown
  invitationSubTotal: string
  invitationFirstStudent: string
  invitationAdditionalStudent: string
  firstSemesterSubTotal: string
  firstSemesterFirstStudent: string
  firstSemesterAdditionalStudent: string
  secondSemesterSubTotal: string
  secondSemesterFirstStudent: string
  secondSemesterAdditionalStudent: string
} => {
  const breakdownInitialValue = {
    count: 0,
    amount: {
      amount: '0.00',
      currencyCode: '',
    },
  }

  const breakdownResult = breakdown.reduce(
    (acc, curr) => {
      return {
        semester1FirstStudentsInfo:
          curr.fee === LicensingFeePerRateBreakdownFeeEnum.Sem1FirstStudent
            ? { ...acc.semester1FirstStudentsInfo, ...curr }
            : acc.semester1FirstStudentsInfo,
        semester1AdditionalStudentInfo:
          curr.fee === LicensingFeePerRateBreakdownFeeEnum.Sem1AdditionalStudent
            ? { ...acc.semester1AdditionalStudentInfo, ...curr }
            : acc.semester1AdditionalStudentInfo,
        semester2FirstStudentsInfo:
          curr.fee === LicensingFeePerRateBreakdownFeeEnum.Sem2FirstStudent
            ? { ...acc.semester2FirstStudentsInfo, ...curr }
            : acc.semester2FirstStudentsInfo,
        semester2AdditionalStudentInfo:
          curr.fee === LicensingFeePerRateBreakdownFeeEnum.Sem2AdditionalStudent
            ? { ...acc.semester2AdditionalStudentInfo, ...curr }
            : acc.semester2AdditionalStudentInfo,
        firstSpotInvitation:
          curr.fee === LicensingFeePerRateBreakdownFeeEnum.FirstSpotInvitation
            ? { ...acc.firstSpotInvitation, ...curr }
            : acc.firstSpotInvitation,
        additionalSpotsInvitation:
          curr.fee ===
          LicensingFeePerRateBreakdownFeeEnum.AdditionalSpotsInvitation
            ? { ...acc.additionalSpotsInvitation, ...curr }
            : acc.additionalSpotsInvitation,
      }
    },
    {
      semester1FirstStudentsInfo: breakdownInitialValue,
      semester1AdditionalStudentInfo: breakdownInitialValue,
      semester2FirstStudentsInfo: breakdownInitialValue,
      semester2AdditionalStudentInfo: breakdownInitialValue,
      firstSpotInvitation: breakdownInitialValue,
      additionalSpotsInvitation: breakdownInitialValue,
    }
  )

  return {
    ...breakdownResult,
    invitationSubTotal: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.firstSpotInvitation.amount.amount
      )
        .times(breakdownResult.firstSpotInvitation.count)
        .plus(
          convertTwoDecimalStringToBig(
            breakdownResult.additionalSpotsInvitation.amount.amount
          ).times(breakdownResult.additionalSpotsInvitation.count)
        )
    ),
    invitationFirstStudent: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.firstSpotInvitation.amount.amount
      ).times(breakdownResult.firstSpotInvitation.count)
    ),
    invitationAdditionalStudent: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.additionalSpotsInvitation.amount.amount
      ).times(breakdownResult.additionalSpotsInvitation.count)
    ),
    firstSemesterSubTotal: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.semester1FirstStudentsInfo.amount.amount
      )
        .times(breakdownResult.semester1FirstStudentsInfo.count)
        .plus(
          convertTwoDecimalStringToBig(
            breakdownResult.semester1AdditionalStudentInfo.amount.amount
          ).times(breakdownResult.semester1AdditionalStudentInfo.count)
        )
    ),
    firstSemesterFirstStudent: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.semester1FirstStudentsInfo.amount.amount
      ).times(breakdownResult.semester1FirstStudentsInfo.count)
    ),
    firstSemesterAdditionalStudent: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.semester1AdditionalStudentInfo.amount.amount
      ).times(breakdownResult.semester1AdditionalStudentInfo.count)
    ),
    secondSemesterSubTotal: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.semester2FirstStudentsInfo.amount.amount
      )
        .times(breakdownResult.semester2FirstStudentsInfo.count)
        .plus(
          convertTwoDecimalStringToBig(
            breakdownResult.semester2AdditionalStudentInfo.amount.amount
          ).times(breakdownResult.semester2AdditionalStudentInfo.count)
        )
    ),
    secondSemesterFirstStudent: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.semester2FirstStudentsInfo.amount.amount
      ).times(breakdownResult.semester2FirstStudentsInfo.count)
    ),
    secondSemesterAdditionalStudent: formatBigFixedTwoDecimals(
      convertTwoDecimalStringToBig(
        breakdownResult.semester2AdditionalStudentInfo.amount.amount
      ).times(breakdownResult.semester2AdditionalStudentInfo.count)
    ),
  }
}
